import { render } from "./IconWarning.vue?vue&type=template&id=9f6b4cf6"
import script from "./IconWarning.vue?vue&type=script&lang=js"
export * from "./IconWarning.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__